import { TxPipelineNeedsInvestigationReason } from '@client/graphql/__generated__/types';
import { match } from 'ts-pattern';

/**
 * Returns a human-readable label for a transaction pipeline needs investigation reason.
 * Uses exhaustive matching to ensure all enum values are handled.
 *
 * @param reason - The investigation reason enum value
 * @returns A descriptive label for the investigation reason
 */
export function getInvestigationReasonLabel(
  reason: TxPipelineNeedsInvestigationReason
): string {
  return match(reason)
    .with(TxPipelineNeedsInvestigationReason.NONE, () => 'OK')
    .with(TxPipelineNeedsInvestigationReason.NO_PIPELINE, () => 'No pipeline')
    .with(
      TxPipelineNeedsInvestigationReason.NOT_IN_CANDIDATES,
      () => 'Has pipeline but not in candidates'
    )
    .with(
      TxPipelineNeedsInvestigationReason.MULTIPLE_CANDIDATES,
      () => 'Multiple candidates'
    )
    .with(
      TxPipelineNeedsInvestigationReason.NO_TARGET_STATE,
      () => 'No target state'
    )
    .with(
      TxPipelineNeedsInvestigationReason.NO_PIPELINES_FOR_TARGET_STATE,
      () => 'No pipelines for state'
    )
    .with(
      TxPipelineNeedsInvestigationReason.HAS_PIPELINE_ZERO_CANDIDATES,
      () => 'Has pipeline but no candidates'
    )
    .exhaustive();
}
